import { ITableConfig } from '@ib-shared/interfaces/table-config.intf';
import { DATA_TYPE } from '@ib-shared/types/data.type';

export const DASHBOARD_TABLE_CONFIG: ITableConfig = {
  title: 'Transactions',
  columns: [
    {
      headerTitle: 'Date',
      field: 'date',
      dataType: DATA_TYPE.DATE,
      sortable: true,
    },
    {
      headerTitle: 'Description',
      field: 'description',
      dataType: DATA_TYPE.TEXT,
    },
    {
      headerTitle: 'Buy Rate',
      field: 'buyRate',
      dataType: DATA_TYPE.NUMBER,
      // sortable: true,
    },
    {
      headerTitle: 'Debit',
      field: 'debit',
      dataType: DATA_TYPE.NUMBER,
      // sortable: true,
    },
    {
      headerTitle: 'Credit',
      field: 'credit',
      dataType: DATA_TYPE.NUMBER,
      // sortable: true,
    },
    {
      headerTitle: 'Balance',
      field: 'balance',
      dataType: DATA_TYPE.NUMBER,
      forceAlignment: 'right',
      // sortable: true,
    },
  ],
};
